export interface Testimonial {
  quote: string
  name: string
  country: string
  photo: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to open several folders before every installation. Now I have one place to organize the case.',
    name: 'Dr. Sofia R.',
    country: 'Mexico',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/79a795a8-24c2-47b8-b673-089b4467b3bc.jpg',
  },
  {
    quote:
      'The case map completely changed how I organize my follow-up information. I can see the case history much faster.',
    name: 'Dr. Andrés G.',
    country: 'Colombia',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/f14b98e7-9517-4100-a0b1-68c683609a29.jpg',
  },
  {
    quote: 'I wanted structure, not another course. The Commander gives me a workflow I can actually use.',
    name: 'Dr. Lucía F.',
    country: 'Spain',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/ccdf9d30-aec6-4932-93ca-d123550e64aa.jpg',
  },
  {
    quote: 'The trackers make it much easier to keep every case organized consistently.',
    name: 'Dr. Martín S.',
    country: 'Chile',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/a9e0e715-ac08-4945-88f1-ded4d9e19082.jpg',
  },
]
